<template>
  <vue-draggable-resizable
    ref="frame"
    :x="x"
    :y="y"
    :w="w"
    :h="h"
    :z="zIndex"
    :parent="true"
    :lock-aspect-ratio="lockAspectRatio"
    class-name="resizable-draggable-frame"
    @resizing="onResize"
    @dragging="onDrag"
  />
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable';
import './css/ResizableFrame.css';

const frameAspectRatio = 800 / 418;

export default {
  name: 'ResizableFrame',

  components: {
    VueDraggableResizable,
  },

  props: {
    width: {
      type: Number,
      default: 100,
    },
    xPos: {
      type: Number,
      default: 0,
    },
    yPos: {
      type: Number,
      default: 0,
    },
    zIndex: {
      type: [Number, String],
      default: 'auto',
    },
    parentHeight: {
      type: Number,
      default: null,
    },
    parentWidth: {
      type: Number,
      default: null,
    },
    position: {
      type: String,
      default: '',
    },
  },

  mounted() {
    this.calculateInitPosition();

    this.update();
  },

  data() {
    return {
      w: null,
      h: null,
      x: null,
      y: null,
      lockAspectRatio: false,
    };
  },
  methods: {
    onDrag(left, top) {
      this.x = left;
      this.y = top;

      this.update();
    },

    onResize(left, top, width, height) {
      this.x = left;
      this.y = top;
      this.w = width;
      this.h = height;

      this.update();
    },

    update() {
      this.$emit('update', {
        x: this.x,
        y: this.y,
        w: this.w,
        h: this.h,
      });
    },

    calculateInitPosition() {
      this.lockAspectRatio = false;
      if (this.position === '') {
        this.x = this.xPos;
        this.y = this.yPos;
        this.w = this.width;
        this.h = this.width / frameAspectRatio;
      } else {
        switch (this.position) {
          case 'center':
            this.x = 0;
            this.w = this.parentWidth ? (this.parentWidth - 1) : this.width;
            this.h = this.w / frameAspectRatio;
            this.y = this.parentHeight
              ? (this.parentHeight - this.h) / 2
              : 0;
            break;
          default:
        }
      }
      this.$nextTick(() => { this.lockAspectRatio = true; });
    },
  },
};
</script>

<style>
.contains-resizable-draggable-frame
{
  overflow: hidden;
}
</style>
<style scoped>
.resizable-draggable-frame {
  position: absolute;
  color: white;
  border: #b758e2 dotted 3px;
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, .5)
}
</style>
